"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logic = void 0;
const __1 = require("..");
const create_fn_1 = require("../utils/create-fn");
const get_arg_1 = require("../utils/get-arg");
/*
## fn.logic.exists

Check if a value exists.

### Arguments

1. (any) The value to check.

Returns true if the value exists, otherwise false. (boolean)
*/
const exists = (0, create_fn_1.createFn)("fn.logic.exists", (args, context) => {
    const value = (0, get_arg_1.getArgUnknown)(args, 1, context);
    return value !== undefined;
});
/*
## fn.logic.iif

Returns one of two values based on a condition.

### Arguments

1. (boolean) The condition to check.
2. (any) The value to return if the condition is true.
3. (any) The value to return if the condition is false.

Returns the value based on the condition. (any)
*/
const iif = (0, create_fn_1.createFn)("fn.logic.iif", (args, context) => {
    const condition = (0, get_arg_1.getArgUnknown)(args, 1, context);
    if (condition) {
        return (0, get_arg_1.getArgUnknown)(args, 2, context);
    }
    else {
        return (0, get_arg_1.getArgUnknown)(args, 3, context);
    }
});
/*
## fn.logic.switch

Returns one of multiple values based on conditions.

### Arguments

1-Infinity. (tuple) An array with two elements. The first element is the condition to check. The second element is the value to return if the condition is true.
Optional last argument. (anything but an array) The value to return if no conditions are true.

Returns the value based on the condition. (any)

### Example

```
fn.logic.switch(
  [1 == 2, "a"],
  [2 == 2, "b"],
  "c"
) // "b"
```
*/
const switchFn = (0, create_fn_1.createFn)("fn.logic.switch", (args, context) => {
    for (const arg of args) {
        if (arg.type === "array") {
            if ((0, __1.execSyntax)(arg.items[0], context)) {
                return (0, __1.execSyntax)(arg.items[1], context);
            }
        }
        else {
            return (0, __1.execSyntax)(arg, context);
        }
    }
    return undefined;
});
exports.logic = {
    exists,
    iif,
    switch: switchFn,
};
//# sourceMappingURL=logic.js.map